import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service'

declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/Parameter/parameter.html'
})

export class ParameterComponent implements OnInit {
    public constants: Constants;
    public parameters: any = [];
    public parameters_Detail: any = [];
    public addParameterData: any = { addParameterData: "" };
    public editParamterData: any = { editParamterData: "" };
    public filterParameterTypeId: any = 1;
    public filterIsActiveStatus: any = "";
    public isAdd: boolean = true;
    public Search: any = "";
    public active = true;
    public taskTypeStatus: any = "";
    public existsValue: boolean = false;
    public existsDescription: boolean = false;
    public showLoader = false;
    public selectedParameterType: string = "";
    public isFormSubmitted: boolean = false;
    constructor(private _httpService: HTTPService, private _sharedService: MySharedService) {
        this.constants = new Constants();
        this.filterIsActiveStatus = this.constants.enumUserStatus["Active"];
    }
    ngOnInit() {
        this.getParametertypelist();
        this.GetStatus();
    }
    newForm() {
        this.active = false;
        setTimeout(() => this.active = true, 0);
    }

    ExportItems() {
        ExportToExcel(this.parameters_Detail, "Parameter Details",
            ["ParameterDescription", "DisplayOrder", "Value", "Status"],
            ["Description", "Display Order", "Value", "Status"]);
    }

    ngAfterViewInit() {

        $("#show-filter").click(function () { $(".filter-form").slideToggle() });
    }

    public AddParameterFormLoad() {
        $('#btnAddParameterForm').trigger('click');
    }

    public ResetForm(form: any) {
        form.reset();
        form.resetForm();
        this.isFormSubmitted = false;
    }

    public GetStatus() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameter', { "ParameterTypeId": this.constants.enumParamterTypeName["UserStatus"] }).subscribe(
            data => {
                this.taskTypeStatus = data["Parameter"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;
            }
        );
    }

    public getParametertypelist() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameterList', { "ParameterTypeId": this.filterParameterTypeId }).subscribe(
            data => {
                this.parameters = data["Parameter"];
                this.getParameter();
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;

            }
        );
    }

    public clearFilter() {
        this.filterParameterTypeId = "";
        this.Search = "";
        this.filterIsActiveStatus = this.constants.enumUserStatus["Active"];
    }


    public CancelAddParameter() {
        this.existsValue = false;
        this.existsDescription = false;
        this.addParameterData = {};
        this.newForm();
        $('#addParameter').modal('hide');
        this.isAdd = true;
    }

    public CancelEditParameter() {
        this.existsValue = false;
        this.existsDescription = false;
        this.editParamterData = {};
        this.newForm();
        $('#editParameter').modal('hide');
        this.isAdd = true;
    }

    public getParameter() {
        this.showLoader = true;
        this._httpService.ajaxPost('Parameter/GetParameter', { "ParameterTypeId": this.filterParameterTypeId }).subscribe(
            data => {
                this.parameters_Detail = data["Parameter"];
                this.selectedParameterType = this.parameters.filter(element => element.ParameterTypeId == this.filterParameterTypeId)[0].ParameterTypeDescription;
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },

            () => {
                this.showLoader = false;
            }
        );
    }

    public AddParameter(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            this.existsValue = false;
            this.existsDescription = false;
            this.parameters_Detail.forEach(element => {
                if (element.Value == this.addParameterData.addAttributeValue) {
                    this.existsValue = true;
                }
                if (element.ParameterDescription.trim().toLowerCase() == this.addParameterData.addDiscriptionName.trim().toLowerCase()) {
                    this.existsDescription = true;
                }
            });
            if (!this.existsValue && !this.existsDescription) {
                let objItem: any = {};
                objItem.Attribute_Id = 0;
                objItem.Visibility = this.addParameterData.addTaskTypeIsActive;
                objItem.Attribute_Name = this.addParameterData.addDiscriptionName;
                objItem.Attribute_Value = this.addParameterData.addAttributeValue;
                objItem.Display_Order = this.addParameterData.addDisplayOrder;
                this.addEditParameter(objItem);
                $('#addParameter').modal('hide');
                this.newForm();
                this.addParameterData = {};
                this.isAdd = true;
            }
        }
    }

    public EditParameter(item: any) {
        $('#btnEditParameterForm').trigger('click');
        this.isAdd = false;
        this.EditParameterChange(item.ParameterId);
    }

    public EditParameterChange(itemId) {
        let objItem: any = {};
        objItem = JSON.parse(JSON.stringify(this.parameters_Detail.filter((Parameter) => Parameter.ParameterId == itemId)[0]));
        this.editParamterData.editAttributeid = objItem.ParameterId;
        this.editParamterData.editDiscriptionName = objItem.ParameterDescription;
        this.editParamterData.editAttributeValue = objItem.Value;
        this.editParamterData.editDisplayOrder = objItem.DisplayOrder;
        this.editParamterData.editTaskTypeIsActive = objItem.Visible;
    }

    public updateParameter(form: any) {
        this.isFormSubmitted = true;
        if (form.form.valid) {
            this.existsValue = false;
            this.existsDescription = false;
            this.parameters_Detail.forEach(element => {
                if (element.ParameterId != this.editParamterData.editAttributeid && element.Value == this.editParamterData.editAttributeValue) {
                    this.existsValue = true;
                }
                if (element.ParameterId != this.editParamterData.editAttributeid && element.ParameterDescription.trim().toLowerCase() == this.editParamterData.editDiscriptionName.trim().toLowerCase()) {
                    this.existsDescription = true;
                }
            })
            if (!this.existsValue && !this.existsDescription) {
                let objItem: any = {};
                objItem.Visibility = 1;
                objItem.Attribute_Id = this.editParamterData.editAttributeid;
                objItem.Attribute_Name = this.editParamterData.editDiscriptionName;
                objItem.Attribute_Value = this.editParamterData.editAttributeValue;
                objItem.Display_Order = this.editParamterData.editDisplayOrder;
                objItem.Visibility = this.editParamterData.editTaskTypeIsActive;
                this.addEditParameter(objItem);
                $('#editParameter').modal('hide');
                this.newForm();
                this.editParamterData = {};
                this.isAdd = true;
            }
        }
    }

    addEditParameter(objItem) {
        objItem.ParameterTypeId = this.filterParameterTypeId;
        this.showLoader = true;
        this._httpService.ajaxPost('Parameter/AddUpdateParameter', objItem).subscribe(
            data => {
                var msg = data["Status"].Message.split('|');
                if (msg.length > 1) {
                    msg[0] = msg[0].toLowerCase();
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                else {
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
                this.getParameter();
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/Parameter/parameter.component.ts
 **/